/**
 * Quem acessa as tabelas de cancelamento (solicitacoes_cancelamento,
 * solicitacoes_cancelamento_historico, termo_cancelamento_logs,
 * cancelamento_alertas).
 *
 * Espelho no front de `public.auth_eh_interno_cancelamento()`
 * (migration 20260916170000_cancelamento_rls_interno.sql). A RLS é a trava
 * real; aqui é só para não mostrar ação que o banco vai recusar. Mudou a
 * lista de um lado, mude do outro.
 */
export const PAPEIS_INTERNOS_CANCELAMENTO = ['adm', 'gerente', 'analista'] as const;

export function podeAcessarCancelamentos(role: string | null | undefined): boolean {
  if (typeof role !== 'string') return false;
  return (PAPEIS_INTERNOS_CANCELAMENTO as readonly string[]).includes(role.trim());
}
